/** Live view of the offline queue for the sync indicator. */
import { useCallback, useEffect, useState } from 'react';
import { listQueue, onQueueChange, syncQueue, type QueueEntry } from './offlineQueue';

export function useQueue(): { entries: QueueEntry[]; pending: number; failed: number; syncing: boolean; syncNow: () => Promise<void> } {
  const [entries, setEntries] = useState<QueueEntry[]>([]);
  const [syncing, setSyncing] = useState(false);
  useEffect(() => {
    let live = true;
    const load = () => void listQueue().then((q) => live && setEntries(q)).catch(() => undefined);
    load();
    const off = onQueueChange(load);
    return () => {
      live = false;
      off();
    };
  }, []);
  const syncNow = useCallback(async () => {
    setSyncing(true);
    try {
      await syncQueue();
    } finally {
      setSyncing(false);
    }
  }, []);
  return {
    entries,
    pending: entries.filter((e) => e.status === 'pending').length,
    failed: entries.filter((e) => e.status === 'failed').length,
    syncing,
    syncNow,
  };
}
